import { defaultGoalsOverviewFilterDocument } from '@griply/utils';
import {
  useGoalsOverviewFilterDocument,
  useUpdateGoalsOverviewFilterDocument,
} from 'features/user';
import React from 'react';
import { GoalListFilterButton } from 'shared/components/connected/goal-list-filter-button';

export const GoalsFilterButton: React.FC = () => {
  const filterDocument = useGoalsOverviewFilterDocument();
  const updateFilterDocument = useUpdateGoalsOverviewFilterDocument();

  // Reset clears only the filters; sorting and grouping are left untouched.
  const handleReset = () => updateFilterDocument({ filters: null });

  return (
    <GoalListFilterButton
      filterDocument={filterDocument}
      defaultFilterDocument={defaultGoalsOverviewFilterDocument}
      onUpdate={updateFilterDocument}
      onReset={handleReset}
    />
  );
};
